import * as t from 'io-ts';
import { optionValueCodec } from '@/services/api/resources/optionSet/codec';
import { recordCodec as entityTypePropertyCodec } from '@/services/api/resources/entityTypeProperty/codec';

const entityItemPropertyValueData = t.type({
  entityTypeProperty: entityTypePropertyCodec,
  valueText: t.union([t.string, t.null]),
  optionValues: t.array(optionValueCodec),
});

export const recordCodec = t.type({
  id: t.number,
  data: entityItemPropertyValueData,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
});

export const formCodec = t.type({
  entityTypePropertyId: t.number,
  valueText: t.union([t.string, t.null]),
  optionValueIds: t.union([t.array(t.number), t.undefined]),
});
